module.exports = __webpack_public_path__ + "img/construction_manager_splash.244b864d.jpg";